<script setup lang="ts">
import { urlChangeTheme } from '@/api/endpoint'
import { URL_BACK } from '@/config/constants'
import { applyTheme } from '@/event/theme/theme'
import stores from '@/storage/stores'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'

const messageResponse = ref<{ message: string; class: string }>({
    message: '',
    class: ''
})
const selectedTheme = ref('')
const showThemeModal = ref(false)
const themes = ['default', 'happy-dark', 'happy-light']

const storeId = computed(() => stores.getStoresData().store_id)

const toggleModalChangeTheme = (e: KeyboardEvent) => {
    if (e.ctrlKey && e.altKey && e.key === 't') {
        showThemeModal.value = !showThemeModal.value
    }
}

const showDevSelector = computed(() => {
    //   return import.meta.env.MODE === 'development' && window.location.hostname === 'localhost'
    return window.location.hostname === 'localhost' && showThemeModal.value === true
})

const handleThemeChange = async (event: Event) => {
    try {
        const target = event.target as HTMLSelectElement
        const theme = target.value
        applyTheme(theme)

        const url = `https://${URL_BACK}/api/${urlChangeTheme}`

        if (storeId.value) {
            const res = await fetch(url, {
                method: 'POST',
                body: JSON.stringify({ theme, store_id: storeId.value }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })

            const response = await res.json()
            messageResponse.value = response
        } else {
            console.log("Le storeID n'est pas chargé")
        }
    } catch (e) {
        console.log(e)
    }
}

onMounted(() => {
    const themeSaved = localStorage.getItem('theme')
    selectedTheme.value = themeSaved ? themeSaved : ''

    window.addEventListener('keydown', toggleModalChangeTheme)
})

onBeforeUnmount(() => {
    window.removeEventListener('keydown', toggleModalChangeTheme)
})
</script>

<template>
    <section v-if="showDevSelector" class="section-change-theme">
        <div class="overlay-change-theme"></div>
        <div class="theme-selector">
            <div class="flex justify-between pb-3">
                <label for="themeSelect">Thème :</label>
                <button @click="showThemeModal = false">X</button>
            </div>
            <select id="themeSelect" v-model="selectedTheme" @change="handleThemeChange">
                <option v-for="theme in themes" :key="theme" :value="theme">
                    {{ theme }}
                </option>
            </select>
            <p class="h-5" :class="messageResponse.class">
                {{ messageResponse.message }}
            </p>
        </div>
    </section>
</template>

<style scoped>
.section-change-theme {
    @apply absolute top-0 left-0 w-full h-full;
}

.overlay-change-theme {
    @apply fixed w-full h-full bg-black opacity-65 top-0 left-0 z-10;
}

.theme-selector {
    @apply flex flex-col top-1/2 left-1/2 justify-center fixed  bg-slate-eronor p-4 rounded-md z-30 w-56;
    transform: translate(-50%, -50%);
}

.theme-selector select {
    @apply text-slate-eronor;
}
</style>
